var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-lx",
    _vm._b(
      { on: { saveClick: _vm.next } },
      "dialog-lx",
      _vm.dialogData,
      false,
      true
    ),
    [
      _c("div", { staticClass: "content-main" }, [
        _c("div", { staticClass: "dialog-header" }, [
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: [["teacher", "admin"], "pro"],
                      expression: "[['teacher', 'admin'], 'pro']",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t("planLxDetail.QXZ"),
                    size: "small",
                  },
                  on: {
                    change: () => {
                      _vm.getLeftList()
                      _vm.pageNo = 1
                    },
                  },
                  model: {
                    value: _vm.dialogSelectValue,
                    callback: function ($$v) {
                      _vm.dialogSelectValue = $$v
                    },
                    expression: "dialogSelectValue",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "prefix",
                      attrs: { slot: "prefix" },
                      slot: "prefix",
                    },
                    [_vm._v(_vm._s(_vm.$t("planLxDetail.BJ")))]
                  ),
                  _c("el-option", {
                    attrs: { value: "", label: _vm.$t("planLxDetail.QBBJ") },
                  }),
                  _vm._l(_vm.dialogOptions, function (item) {
                    return _c("el-option", {
                      key: item.classId,
                      attrs: { value: item.className, label: item.className },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c("div", [
            _vm._v("·" + _vm._s(_vm.$t("planLxDetail.QXZCJBCLXDXS")) + "·"),
          ]),
        ]),
        _c("div", { staticClass: "dialog-content" }, [
          _c("div", { staticClass: "content-left" }, [
            _c(
              "div",
              { staticClass: "table-header" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.poolAllAdd },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.QBDR")) + " ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.playerPoolAdd },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.DRXZ")) + " ")]
                ),
                _c("el-input", {
                  staticStyle: { margin: "0 16px" },
                  attrs: {
                    placeholder: _vm.$t("planLxDetail.QSRNR"),
                    size: "mini",
                  },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.getLeftList.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.leftHeaderVal,
                    callback: function ($$v) {
                      _vm.leftHeaderVal = $$v
                    },
                    expression: "leftHeaderVal",
                  },
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.getLeftList },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.CX")))]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "table-box" },
              [
                _c("c-table", {
                  attrs: {
                    tableData: _vm.leftTableData,
                    tableStr: "left",
                    tableHeader: _vm.tableHeader,
                    TableHeight: (_vm.total > 100 ? 276 : 316) + "px",
                  },
                  on: { operation: _vm.operation },
                }),
                _c("paging", {
                  attrs: { total: _vm.total, pageNo: _vm.pageNo },
                  on: {
                    currentChange: (pageVal) => {
                      this.pageNo = pageVal
                      _vm.getLeftList()
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "center-content" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.maxPersonCount > 0,
                    expression: "maxPersonCount > 0",
                  },
                ],
                staticClass: "upper",
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("planLxDetail.SX")) +
                    " " +
                    _vm._s(_vm.maxPersonCount) +
                    " "
                ),
              ]
            ),
            _c("img", {
              attrs: { src: require("@/assets/image/xz-1@2x.png") },
              on: { click: _vm.playerPoolAdd },
            }),
            _c("img", {
              staticClass: "img",
              attrs: { src: require("@/assets/image/zy-1@2x.png") },
              on: { click: _vm.playerPoolDel },
            }),
            _c("p", [
              _vm._v(" " + _vm._s(_vm.$t("planLxDetail.YX")) + " "),
              _c("span", [_vm._v(_vm._s(_vm.activeTableData.length))]),
              _vm._v(" " + _vm._s(_vm.$t("planLxDetail.R")) + " "),
            ]),
          ]),
          _c("div", { staticClass: "content-right" }, [
            _c(
              "div",
              { staticClass: "table-header" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.playerPoolDel(true)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.QBSC")) + " ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.playerPoolDel },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.SCQZ")) + " ")]
                ),
                _c("el-input", {
                  staticStyle: { margin: "0 16px" },
                  attrs: { placeholder: "请输入内容", size: "mini" },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.seachRightTableData.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.rightHeaderVal,
                    callback: function ($$v) {
                      _vm.rightHeaderVal = $$v
                    },
                    expression: "rightHeaderVal",
                  },
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.seachRightTableData },
                  },
                  [_vm._v(_vm._s(_vm.$t("planLxDetail.CX")) + " ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "table-box" },
              [
                _c("c-table", {
                  attrs: {
                    tableData: _vm.rightTableData,
                    tableStr: "right",
                    tableHeader: _vm.rightTableHeader,
                    TableHeight: "316px",
                  },
                  on: { operation: _vm.operation },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }